import React from 'react'
import * as h from '../../helpers/helpers';
import * as rf from '../../data/reportFunctions';
import { H1, TXC_I, TCH, TB_SUB_H1, TB_LIST, TXC } from "../../styles/urar-styles";

export function ADDD_SUMMARY({actionableOnly}) {

	var ctrt = global.ptr.subProp.GetCostToRepairType();
	var bItemized = ctrt === "Itemized";
	var bHaveActionalbeDefects = false;
	var bHaveCostToRepair = false;
	var bHaveDefects = false;

	if (global.ptr.subProp.propertyDefect !== null) {

		var bSiteDefects = global.ptr.subSite.siteDetail.siteDefectsExistIndicator ?? false;
		var bDwellingExteriorDefects = global.ptr.subDwelling.dwellingExteriorDefectsExistIndicator ?? false;
		var bUnitInteriorDefects = global.ptr.subImprovs.GetUnitDefectsExist();
		var bOutbuildingDefects = global.ptr.subImprovs.GetOutbuildingDefectsExist();
		var bVehicleStorageDefects = global.ptr.subDetail.vehicleStorageDefectsExistIndicator ?? false;
		var bAmenitiesDefects = global.ptr.subDetail.subjectPropertyAmenitiesDefectsExistIndicator ?? false;

		bHaveDefects =
			bSiteDefects ||
			bDwellingExteriorDefects ||
			bUnitInteriorDefects ||
			bOutbuildingDefects ||
			bVehicleStorageDefects ||
			bAmenitiesDefects;

		//console.log("haveDefects: ", bHaveDefects);

		var defs;
		var cdefs;
		var allDefects = [];
		var defList = [];
		if (bHaveDefects) 
		{
			// Combine defects from multiple sources
			defs = getDefects("DEFECT_ContainsDefectOf_SITE", global.ptr.subSite.label);
			allDefects.push(...defs);
			cdefs = collectDefectRows("Site", defs, actionableOnly);
			if (cdefs) defList.push(cdefs);

			// Dwelling Exterior
			global.ptr.subImprovsList.forEach(improv => {
				if (["Dwelling","Outbuilding"].includes(improv.improvementDetail.improvementType)) {
					defs = getImprovementDefects(improv);
					allDefects.push(...defs);

					var heading = "Dwelling Exterior";
					if (global.ptr.subDetail.livingUnitExcludingADUCount > 1)
						heading += " - " + improv.structure.structureDetail.structureIdentifier;

					cdefs = collectDefectRows(heading, defs, actionableOnly);
					if (cdefs) defList.push(cdefs);
				}
			})

			// Dwelling Unit Interior
			global.ptr.subDwellingList.forEach(dwelling => {
				var heading = "Unit Interior";
				if (dwelling.improvementDetail.improvementType === "Dwelling") {
					if (global.ptr.subDetail.livingUnitExcludingADUCount > 1)
						heading += " - " + dwelling.structure.structureDetail.structureIdentifier;

					dwelling.propertyUnits.forEach(pu => {
						defs = getPropertyUnitDefects(pu);
						allDefects.push(...defs);

						if (global.ptr.subDetail.livingUnitExcludingADUCount > 1 || global.ptr.subDetail.accessoryDwellingUnitTotalCount > 0)
							heading += " - " + pu.propertyUnitDetail.unitIdentifier;

						cdefs = collectDefectRows(heading, defs, actionableOnly);
						if (cdefs) defList.push(cdefs);
					})
				}
			})

			// Outbuilding
			global.ptr.subDwellingList.forEach(dwelling => {
				if (dwelling.improvementDetail.improvementType === "Outbuilding") {
					defs = getImprovementDefects(dwelling);
					allDefects.push(...defs);

					var heading = "Outbuilding";
					if (global.ptr.subDetail.livingUnitExcludingADUCount > 1)
						heading += " - " + dwelling.GetOutbuildingType();

					cdefs = collectDefectRows(heading, defs, actionableOnly);
					if (cdefs) defList.push(cdefs);
				}
			})

			// Outbuilding Unit Interior
			global.ptr.subDwellingList.forEach(dwelling => {
				var heading = "Unit Interior";
				if (dwelling.improvementDetail.improvementType === "Outbuilding") {
					if (global.ptr.subDetail.livingUnitExcludingADUCount > 1)
						heading += " - " + dwelling.structure.structureDetail.structureIdentifier;

					dwelling.propertyUnits.forEach(pu => {
						defs = getPropertyUnitDefects(pu);
						allDefects.push(...defs);

						if (global.ptr.subDetail.livingUnitExcludingADUCount > 1 || global.ptr.subDetail.accessoryDwellingUnitTotalCount > 0)
							heading += " - " + pu.propertyUnitDetail.unitIdentifier;

						cdefs = collectDefectRows(heading, defs, actionableOnly);
						if (cdefs) defList.push(cdefs);
						console.log(defs, cdefs);
					})
				}
			})

			defs = getDefects("DEFECT_ContainsDefectOf_CAR_STORAGE", global.ptr.subSite.label);
			allDefects.push(...defs);
			cdefs = collectDefectRows("Vehicle Storage", defs, actionableOnly);
			if (cdefs) defList.push(cdefs);

			defs = getDefects("DEFECT_ContainsDefectOf_AMENITY");
			allDefects.push(...defs);
			cdefs = collectAmenityDefects("Subject Property Amenities", defs, actionableOnly);
			if (cdefs) defList.push(cdefs);

			// Check each defect for actionable items or repair costs
			for (const defect of allDefects) {
				//console.log("defect: ", defect);
				if (defect.defectDetail.defectItemRecommendedActionType !== "None") {
						bHaveActionalbeDefects = true;
				}
				if (defect.defectDetail.defectItemEstimatedCostToRepairAmount.HasNonZeroValue()) {
						bHaveCostToRepair = true;
				}
			}
		}
		//console.log("allDefects: ", allDefects);
		//console.log("defectsList: ", defList);
	}
	//console.log("defects: ", actionableOnly, bHaveDefects, bHaveActionalbeDefects, bHaveCostToRepair);

	// warning message
	if ((bItemized && !bHaveCostToRepair) || (!bItemized && bHaveCostToRepair)) {
		console.log("Itemized discrepancy:", ctrt, bItemized, bHaveCostToRepair);
	}

	var title = "Apparent Defects, Damages, Deficiencies";
	if (actionableOnly) title += " Requiring Action";

	if (!bHaveDefects) {
		return (
		<>
			<H1 title={title} />
			<TXC comment={"None"} />
		</>
		)
	}

	var widths = bHaveCostToRepair ? [165, 165, 255, 165, 165, 165] : [190, 190, 320, 190, 190];
	var tblHdr = bHaveCostToRepair ? ["Feature", "Location", "Description", "Affects Soundness\nor Structural\nIntegrity", "Recommended\nAction", "Estimated Cost to\nRepair"]
							: ["Feature", "Location", "Description", "Affects Soundness or\nStructural Integrity", "Recommended\nAction"];

	var bShowTable = true;
	var header = "The items listed below represent the As Is condition as of the effective date of this report";
	if (actionableOnly) {
		if (!bHaveActionalbeDefects) {
			header = "There are no apparent defects, damages, or deficiencies requiring action. For details, reference the 'Reconciliation' section";
			bShowTable = false;
		}
	}

	return (
		<>
			<H1 title={title} />
			<TXC_I comment={header} />
			{ bShowTable &&
			<>
				<ADDD_SUM titles={tblHdr} values={defList} widths={widths} />
				<ADDD_TOTAL />
			</>
			}
		</>
	)
}

function ADDD_TOTAL() {
	if (global.ptr.subProp.GetCostToRepairType() !== "Itemized") return undefined;

	let total = global.ptr.subProp.GetCostToRepairTotalAmount().ToDollarAmount();

	return (
		<div className='flex flex-row w-[1080px] border-gray-500 border-t-2 mpb' >
			<div className='w-[750px]' />
			<div className='w-[165px] bg-gray-400 text-right text-white pr-2' >Total Cost</div>
			<div className='w-[165px] text-right text-white pr-4 bg-gray-400' >{total}</div>
		</div>
	)

}
		
function ADDD_SUM({titles, values, widths}) {
	//console.log("ADDD: ", header, subtitle, values);

	return (
		<div>
			<TCH titles={titles} widths={widths} />
			{
				values.map((d, i) => {
					var hdr = d.title;
					var end = (values.length-1) === i;
					return (
						<div key={i}>
							<TB_SUB_H1 header={hdr} />
							<TB_LIST values={d.defects} widths={widths} notop />
						</div>
					)
				})
			}
		</div>
	)
}

export function ADDD({values, subtitle}) {
	//console.log("ADDD: ", subtitle, values);
	var title = "Apparent Defects, Damages, Deficiencies";
	if (title) title += " " + subtitle;
	var showTable = (values && values.length > 0) ? true : false;
	var header = "The items listed below represent the As Is condition as of the effective date of this report";
	return (
		<div>
				<H1 title={title} />
				{ !showTable &&
					<TXC comment={"None"} />
				}
				{ showTable &&
				<>
					<TXC_I comment={header} />
					<TCH titles={["Feature", "Location", "Description", "Affects Soundness or\nStructural Integrity", "Recommended\nAction"]} widths={[190, 190, 320, 190, 190]} />
					<TB_LIST values={values} widths={[190, 190, 320, 190, 190]} />
				</>
				}
		</div>
	)
}


export function getImprovementDefects(imp) {
	const impDefects = global.ptr.subProp.propertyDefect.GetDefectsByArcRole("DEFECT_ContainsDefectOf_IMPROVEMENT", imp.label);
	return impDefects;
}

export function getPropertyUnitDefects(unit) {
	const puDefects = global.ptr.subProp.propertyDefect.GetDefectsByArcRole("DEFECT_ContainsDefectOf_PROPERTY_UNIT", unit.label);
	return puDefects;
}

export function getDefects(arcRole, arcRoleTo = null, bActionRequired = false) {
	const intDefects = [];
	const rels = arcRoleTo
		? global.ptr.relationships.GetRelationshipsTo(arcRole, arcRoleTo)
		: global.ptr.relationships.GetRelationshipsByArcFrom(arcRole);

	//console.log("gd: ", arcRole, arcRoleTo, rels);
	rels.forEach(rel => {
		const defects = global.ptr.subProp.propertyDefect.GetDefectsByLabels(rel);

		if (!bActionRequired) {
			intDefects.push(...defects);
		} else {
			defects.forEach(defect => {
				if (defect.defectDetail.defectItemRecommendedActionType !== "None") {
					intDefects.push(defect);
				}
			});
		}
	});

	return intDefects;
}

function collectDefectRows(collection, defects, actionableOnly) {

	if (defects.length === 0) return null;

	var section = {
		title: collection,
		defects: []
	}

	defects.forEach((defect) => {
		//console.log("defect: ", defect);
		if (!actionableOnly || defect.defectDetail.defectItemRecommendedActionType !=="None") {
			var feature = defect.GetComponentLabelType();
			var location = defect.GetLocationType();
			var descr = defect.defectDetail.defectItemDescription;
			var soundness = h.yesNo(defect.defectDetail.defectItemAffectsSoundnessStructuralIntegrityIndicator)
			var action = h.toEnumText(defect.defectDetail.defectItemRecommendedActionType);
			var cost = h.amountOrEmpty(defect.defectDetail.defectItemEstimatedCostToRepairAmount);
			if (cost) cost = ">" + cost;

			var row = [feature, location, descr, soundness, action, cost];
			section.defects.push(row);
		}
	})

	if (section.defects.length === 0) return null;
	return section;
}

function collectAmenityDefects(collection, defects, actionableOnly) {

	if (defects.length === 0) return null;

	var section = {
		title: collection,
		defects: []
	}

	defects.forEach((defect) => {
		// get the corresponding amenity
		var rels = global.ptr.relationships.GetRelationshipsFrom("DEFECT_ContainsDefectOf_AMENITY", defect.label);
		var amenity = global.ptr.subProp.GetAmenityByLabel(rels[0]);

		//console.log("defect: ", defect);
		if (!actionableOnly || defect.defectDetail.defectItemRecommendedActionType !=="None") {
			var row = rf.GetAmenityDefectRow(defect);
			section.defects.push(row);
		}
	})

	if (section.defects.length === 0) return null;
	return section;
}

